type ServerTextValueOptions = {
    controller: string;
    fallback: string;
    hasValue: boolean;
    name: string;
    value: string;
};

const warnedMissingServerTextValues = new Set<string>();

export function serverTextValue({ controller, fallback, hasValue, name, value }: ServerTextValueOptions): string {
    if (hasValue && value.trim().length > 0) {
        return value;
    }

    const warningKey = `${controller}:${name}`;
    if (!warnedMissingServerTextValues.has(warningKey)) {
        warnedMissingServerTextValues.add(warningKey);
        console.warn(`[${controller}] missing server translation value: ${name}; using fallback text`);
    }

    return fallback;
}
